import { __extends } from "tslib";
import React from 'react';
import StatusEditPopup from '../StatusEditPopup';
import WriterPopup from '../WriterPopup';
import { EditorState, convertToRaw, } from '@wix/draft-js';
import { convertToClientStorageState } from '../DaEditorWrapper/utils';
import { stripFormattingForEditorFlavour } from '../DaEditorWrapper/Filter/formatting';
import { EditorFlavourConfigs } from '../DaEditorWrapper/config';
var defaultProps = {
    mode: 'status',
};
var PostPopup = /** @class */ (function (_super) {
    __extends(PostPopup, _super);
    function PostPopup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            mode: _this.props.mode || defaultProps.mode,
            selectionState: null,
            hasUnsavedChanges: false,
        };
        _this.handleSwitchMode = function (rawContentState, editorContent, featuresData, hasUnsavedChanges, selectionState) {
            if (_this.state.mode === 'journal') {
                // Switching back to status, strip unsupported things
                var newEditorState = EditorState.createWithContent(editorContent);
                newEditorState = stripFormattingForEditorFlavour(EditorFlavourConfigs.STATUS_LONG, newEditorState);
                _this.sharedEditorState = {
                    excerpt: '',
                    html: {
                        type: 'draft',
                        markup: JSON.stringify(convertToRaw(newEditorState.getCurrentContent())),
                        features: JSON.stringify(featuresData),
                    },
                };
            }
            else {
                _this.sharedEditorState = convertToClientStorageState(rawContentState, editorContent, featuresData).editorText;
            }
            var mode = (_this.state.mode === 'journal'
                ? 'status'
                : 'journal');
            _this.setState({ mode: mode, selectionState: selectionState, hasUnsavedChanges: hasUnsavedChanges });
        };
        return _this;
    }
    PostPopup.prototype.render = function () {
        var _a = this.state, mode = _a.mode, selectionState = _a.selectionState, hasUnsavedChanges = _a.hasUnsavedChanges;
        var Component = mode === 'journal' ? WriterPopup : StatusEditPopup;
        return (React.createElement(Component, { onClose: this.props.onClose, onSwitchMode: this.handleSwitchMode, editorInitState: this.sharedEditorState, deviation: this.props.deviation, selectionState: selectionState, hasUnsavedChanges: hasUnsavedChanges }));
    };
    PostPopup.defaultProps = defaultProps;
    return PostPopup;
}(React.Component));
export default PostPopup;
//# sourceMappingURL=PostPopup.js.map